
import React from 'react';

const CaseStudy: React.FC = () => {
  return (
    <div className="bg-itmgmt-light-blue/10 border border-itmgmt-light-blue p-6 rounded-lg my-8">
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">Case Study: Main Street Accounting Firm</h3>
      <p className="text-gray-700 mb-4">
        Consider the experience of a 12-person accounting firm that implemented zero-trust principles following a ransomware scare:
      </p>
      <ul className="list-disc ml-6 mb-4 text-gray-700">
        <li className="mb-2">They deployed MFA across all applications, including email and practice management software</li>
        <li className="mb-2">They segmented their network, separating client data from general office functions</li>
        <li className="mb-2">They implemented role-based access controls, ensuring junior staff couldn't access senior client information</li>
        <li className="mb-2">They adopted continuous monitoring with automated alerts</li>
      </ul>
      <p className="text-gray-700 mb-2">
        <strong>Total investment:</strong> Less than $8,000, primarily in consulting and software subscriptions.
      </p>
      <p className="text-gray-700 font-medium">
        <strong>Result:</strong> When targeted by a sophisticated phishing campaign six months later, the attack was automatically 
        contained to a single endpoint with no data compromise or operational disruption.
      </p>
    </div>
  );
};

export default CaseStudy;
